import React from 'react';
import CourseItem from './CourseItem';
// import '../view_DetalleCategoria.scss'
import { ScrollView } from 'devextreme-react';
import { Component } from 'react';

interface IProps {
  data:any,
  deleteCourse: any
}

interface IState {
  courseItems: any
}
class CoursesItems extends Component<IProps, IState> {
  constructor(props: IProps) {
      super(props);
      this.state = {
        courseItems: null
      }
  }

  componentDidMount() {
    this.setState({ courseItems: <CourseItem prop={this.props.data} deleteCourse={this.props.deleteCourse} /> })
  }
  
  render() {
    return (<div>
      <ScrollView> <div className="tabpanel-item">{this.state.courseItems}</div> </ScrollView>
    </div>
    )
  }
}
export default CoursesItems;